import { render, staticRenderFns } from "./Subscriptions.vue?vue&type=template&id=47b8ae9e&scoped=true"
import script from "./Subscriptions.vue?vue&type=script&lang=ts"
export * from "./Subscriptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b8ae9e",
  null
  
)

export default component.exports